
export default class MainMenu {
    
    static get selector() {
        return '.mainMenu';
    }

    constructor(el) {
        this.el = el;
        this.submenus = this.getSubmenus();
        this.burger = window.document.querySelector('.gotomenu');
        this.setEvents();
    }

    getSubmenus() {
        let submenus = [];
        let submenusElements = this.el.querySelectorAll('.mainMenu__subMenu');
        submenusElements.forEach(element => {
            let submenu = {};
                submenu.isActive = false;
                submenu.el = element;
                submenu.id = element.id;
                submenu.link = this.el.querySelector('a[href="#'+ submenu.id + '"]');
                submenus.push(submenu);
            });
        return submenus;
    }

    activeSubmenu(submenu) {
        if(submenu.isActive) return;
        this.desactiveAllSubmenu();
        submenu.el.classList.add('mainMenu__subMenu--active');
        submenu.link.classList.add('mainMenu__link--active');

        submenu.isActive = true;
    }
    desactiveSubmenu(submenu) {
        if(!submenu.isActive) return;
        submenu.el.classList.remove('mainMenu__subMenu--active');
        submenu.link.classList.remove('mainMenu__link--active');

        submenu.isActive = false;
    }
    desactiveAllSubmenu() {
        this.submenus.forEach( submenu => {
            if(submenu.isActive) this.desactiveSubmenu(submenu);
        });
    }

    open() {
        if(this.isOpen) return;
        window.scrollTo(0,0);
        document.body.classList.add('menuOpen');
        document.body.style.height = window.outerHeight+'px';
        this.isOpen = true;
    }

    close() {
        if(!this.isOpen) return;
        document.body.classList.remove('menuOpen');
        document.body.style.height = "";
        this.isOpen = false;
    }

    setEvents() {
        this.submenus.forEach( submenu =>{
            submenu.link.addEventListener('click',e => {this.e_clickSubmenu(e, submenu)} );
        });
        //window.addEventListener('resize', this.e_resize.bind(this));
        this.burger.addEventListener('click', this.e_clickBurger.bind(this));
    }

    e_clickBurger(e) {
        e.preventDefault();
        e.target.blur();
        if(!this.isOpen) this.open();
        else this.close();
    }

    e_clickSubmenu(e, submenu) {
        //e.target.blur();

        e.preventDefault();
        //this.activeSubmenu(submenu);
    }

    e_resize(e) {
        this.close();
    }


}